module.exports = __webpack_public_path__ + "static/media/recipes.5cd4e3d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recipes.png
// module id = 285
// module chunks = 1